import { useEffect, useState } from 'react';
import { useForegroundInterval } from 'shared/src/hooks';
import {
  computeCountdownDisplay,
  type CountdownDisplay,
} from '../utils/computeCountdownDisplay';

export type { CountdownDisplay };

/**
 * PDP 카운트다운 표시값. 매초 갱신하되 만료 시 '00:00:00' 고정 + 정지.
 * 포그라운드/포커스일 때만 tick (useForegroundInterval).
 * finishedAt이 바뀌면(warm 재진입 + refetch로 새 특가 등) 상태를 재계산해 interval을 재개한다.
 */
export const useCountdownDisplay = (finishedAt: string): CountdownDisplay => {
  const [display, setDisplay] = useState<CountdownDisplay>(() =>
    computeCountdownDisplay(finishedAt),
  );

  useEffect(() => {
    setDisplay(computeCountdownDisplay(finishedAt));
  }, [finishedAt]);

  useForegroundInterval(
    () => setDisplay(computeCountdownDisplay(finishedAt)),
    display.isExpired ? null : 1000,
  );

  return display;
};
